import * as Sentry from '@sentry/react';

export const IGNORED_ERRORS = [
  "Can't find variable: googletag",
  "Can't find variable: snowplow",
  "Can't find variable: iom",
  'al.optimizely.get is not a function.',
  'Non-Error promise rejection captured', // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/16
  'sharedStorage is disabled',
];

export const EXCLUDED_FILENAMES = [
  'gtm.js',
  '<anonymous>',
  'otBannerSdk.js',
  'cdn.optimizely.com',
  'script.hotjar.com',
  'pagead',
  'gpt.js',
  'webkit-masked-url',
  'libtrc',
  'collect.js',
];

export const filterEvent = (event: Sentry.ErrorEvent) => {
  if (isExcludedFilenameEvent(event)) {
    return null;
  }

  return event;
};

const isExcludedFilenameEvent = (event: Sentry.Event) => {
  const errorFrames = event.exception?.values?.[0]?.stacktrace?.frames;

  return EXCLUDED_FILENAMES.some(exFilename =>
    (errorFrames ?? []).some(frame => frame.filename?.includes(exFilename))
  );
};

export const initialiseSentry = (dsn?: string, release?: string) => {
  Sentry.init({
    dsn,
    release,
    ignoreErrors: IGNORED_ERRORS,
    beforeSend: event => filterEvent(event),
  });
};
